import { identity } from 'fp-ts/es6/function';
import * as O from 'fp-ts/es6/Option';
// This `pipe` version is deprecated, but provided by `fp-ts` v2.0.1 and higher.
import { pipe } from 'fp-ts/es6/pipeable';
var PARSER_URI = 'fp-ts-routing/Parser';
/**
 * @category parsers
 * @since 0.4.0
 */
var Parser = /** @class */ (function () {
    function Parser(run) {
        this.run = run;
    }
    /**
     * @since 0.4.0
     */
    Parser.of = function (a) {
        return new Parser(function (s) { return O.some([a, s]); });
    };
    /**
     * @since 0.4.0
     */
    Parser.prototype.map = function (f) {
        return this.chain(function (a) { return Parser.of(f(a)); }); // <= derived
    };
    /**
     * @since 0.4.0
     */
    Parser.prototype.ap = function (fab) {
        var _this = this;
        return fab.chain(function (f) { return _this.map(f); }); // <= derived
    };
    /**
     * @since 0.4.0
     */
    Parser.prototype.chain = function (f) {
        var _this = this;
        return new Parser(function (r) {
            return pipe(_this.run(r), O.chain(function (_a) {
                var a = _a[0], r2 = _a[1];
                return f(a).run(r2);
            }));
        });
    };
    /**
     * @since 0.4.0
     */
    Parser.prototype.alt = function (that) {
        var _this = this;
        return new Parser(function (r) {
            return pipe(_this.run(r), O.alt(function () { return that.run(r); }));
        });
    };
    /**
     * @since 0.4.0
     */
    Parser.prototype.then = function (that) {
        return that.ap(this.map(assign));
    };
    return Parser;
}());
export { Parser };
/**
 * @category parsers
 * @since 0.4.0
 */
export var zero = function () { return new Parser(function () { return O.none; }); };
/**
 * @category parsers
 * @since 0.4.0
 */
export var parse = function (parser, r, a) {
    return pipe(parser.run(r), O.fold(function () { return a; }, function (_a) {
        var x = _a[0];
        return x;
    }));
};
/**
 * @category parsers
 * @since 0.5.1
 */
export var getParserMonoid = function () { return ({
    concat: function (x, y) { return x.alt(y); },
    empty: zero()
}); };
/**
 * @category parsers
 * @since 0.5.1
 */
export var parser = {
    URI: PARSER_URI,
    map: function (ma, f) { return ma.map(f); },
    of: Parser.of,
    ap: function (mab, ma) { return ma.ap(mab); },
    chain: function (ma, f) { return ma.chain(f); },
    alt: function (fx, f) {
        return new Parser(function (r) {
            return pipe(fx.run(r), O.alt(function () { return f().run(r); }));
        });
    },
    zero: zero
};
/**
 * @category parsers
 * @since 0.5.1
 */
export var alt = function (that) {
    return function (fa) {
        return parser.alt(fa, that);
    };
};
/**
 * @category parsers
 * @since 0.5.1
 */
export var ap = function (fa) {
    return function (fab) {
        return parser.ap(fab, fa);
    };
};
// taken from fp-ts 2.0.1 https://github.com/gcanti/fp-ts/blob/2.0.1/src/pipeable.ts#L1028
/**
 * @category parsers
 * @since 0.5.1
 */
export var apFirst = function (fb) {
    return function (fa) {
        return parser.ap(parser.map(fa, function (a) { return function () { return a; }; }), fb);
    };
};
// taken from fp-ts 2.0.1 https://github.com/gcanti/fp-ts/blob/2.0.1/src/pipeable.ts#L1031
/**
 * @category parsers
 * @since 0.5.1
 */
export var apSecond = function (fb) {
    return function (fa) {
        return parser.ap(parser.map(fa, function () { return function (b) { return b; }; }), fb);
    };
};
/**
 * @category parsers
 * @since 0.5.1
 */
export var chain = function (f) {
    return function (ma) {
        return parser.chain(ma, f);
    };
};
/**
 * @category parsers
 * @since 0.5.1
 */
export var chainFirst = function (f) {
    return function (ma) {
        return parser.chain(ma, function (a) { return parser.map(f(a), function () { return a; }); });
    };
};
/**
 * @category parsers
 * @since 0.5.1
 */
export var flatten = function (mma) { return parser.chain(mma, identity); };
/**
 * @category parsers
 * @since 0.5.1
 */
export var map = function (f) {
    return function (fa) {
        return parser.map(fa, f);
    };
};
/**
 * @category parsers
 * @since 0.6.0
 */
export var then = function (fb) {
    return function (fa) {
        return fa.then(fb);
    };
};
// --- Helpers
var assign = function (a) {
    return function (b) {
        return Object.assign({}, a, b);
    };
};
//# sourceMappingURL=parser.js.map